import React from 'react';

import Body from './Body';
import Container from './Container';
import closeModal from "js/components/core/Modal/CloseModal";
import closeButton from "js/components/common/UserQuestion/QuestionForm/CloseButton";

export default ({onClick}) => (
  <Container>
    <h5 style={{fontWeight:"bold"}}>About the discount sales</h5>
    <Body>
      <p>
        Please hold on a second. A special code is being generated for you to send to your customers. This code is valid for 3 months.Please hold on a second. A special code is being generated for you to send to your customers. This code is valid for 3 months.Please hold on a second. A special code is being generated for you to send to your customers. This code is valid for 3 months.Please hold on a second. A special code is being generated for you to send to your customers. This code is valid for 3 months.Please hold on a second. A special code is being generated for you to send to your customers. This code is valid for 3 months.Please hold on a second. A special code is being generated for you to send to your customers. This code is valid for 3 months.
      </p>
      <button className="btn btn-pod tw-bg-secondary tw-py-3 tw-w-full tw-rounded-lg tw-mt-6 tw-text-white mb-3"
              onClick={onClick}>
        Ok, got it
      </button>
      <p className="text-center tw-text-secondary">Terms and conditions</p>
    </Body>
  </Container>
);
